<template>
  <v-card>
    <v-form>
      <v-card-text>
        <v-flex>
          <v-text-field
            label="Question..."
            v-model="question"
            required
          ></v-text-field>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          @click="submit"
        >Submit</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import axios from 'axios'
import config from '../../../../configApi'
const apiUrl = config.apiUrl

export default {
  data () {
    return {
      question: null
    }
  },
  methods: {
    submit: function () {
      this.onSubmit()
    },
    onSubmit: function () {
      var formData = new FormData()
      formData.append('module_id', this.moduleId)
      formData.append('question', this.question)
      axios.post(apiUrl + '/questionnaire', formData).then((res) => {
        console.log(res)
      })
    }
  },
  props: {
    apiUrl: String,
    moduleId: String
  }
}
</script>


// WEBPACK FOOTER //
// src/components/admin/module/addQuestionForm.vue